// extracted by mini-css-extract-plugin
module.exports = {"active":"blocked_active__1zuQ-","disabled":"blocked_disabled__3AnBU"};